import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import type { ExtractInjectionAPI, PMPluginFactoryParams } from '@atlaskit/editor-common/types';
import type { EditorState } from '@atlaskit/editor-prosemirror/state';
import { DecorationSet } from '@atlaskit/editor-prosemirror/view';

import type { AIDefinitionsPlugin, AIDefinitionsPluginConfig } from '../../types';

import { createPluginState, getPluginState } from './plugin-factory';
import { aiDefinitionsPluginKey } from './plugin-key';
import { getInitialState } from './state';

export const createPlugin = (
	{ dispatch }: PMPluginFactoryParams,
	api: ExtractInjectionAPI<AIDefinitionsPlugin> | undefined,
	config: AIDefinitionsPluginConfig,
) => {
	return new SafePlugin({
		key: aiDefinitionsPluginKey,

		state: createPluginState(dispatch, () => getInitialState()),

		props: {
			decorations(state: EditorState) {
				const { keywordDecorations } = getPluginState(state);
				const livePageMode = api?.editorViewMode.sharedState.currentState()?.mode;
				if (config.isLivePage && livePageMode === 'view') {
					return keywordDecorations;
				} else {
					return DecorationSet.empty;
				}
			},
		},
	});
};
